var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#5073DC",
    rx: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F6FDFE",
    d: "M58 36.036c2.667 1.54 2.667 5.389 0 6.928l-24.75 14.29c-2.667 1.54-6-.385-6-3.465V25.211c0-3.08 3.333-5.004 6-3.464z"
  })));
};
export default SvgPlayButton;